export function waitForTelegramWebApp(retryInterval = 100, maxRetries = 50) {
    return new Promise((resolve, reject) => {
        let attempts = 0

        const checkTelegramReady = () => {
            if (window.Telegram && window.Telegram.WebApp) {
                resolve(window.Telegram.WebApp) // Возвращаем объект WebApp через resolve
            } else {
                attempts++
                if (attempts < maxRetries) {
                    setTimeout(checkTelegramReady, retryInterval)
                } else {
                    reject(new Error('Telegram WebApp initialization failed: max retries exceeded'))
                }
            }
        }

        checkTelegramReady()
    })
}
